<template>
  <div class="products-tea-container">
    <app-navbar8 logoSrc="/logo_trans-1500h.png">
      <template v-slot:link1>
        <div class="products-tea-fragment10">
          <span class="products-tea-text10">#home</span>
        </div>
      </template>
      <template v-slot:link2>
        <div class="products-tea-fragment11">
          <span class="products-tea-text11">#products</span>
        </div>
      </template>
      <template v-slot:link3>
        <div class="products-tea-fragment12">
          <span class="products-tea-text12">#services</span>
        </div>
      </template>
      <template v-slot:link4>
        <div class="products-tea-fragment13">
          <span class="products-tea-text13">#contact</span>
        </div>
      </template>
      <template v-slot:page1>
        <div class="products-tea-fragment14">
          <span class="products-tea-text14">Home</span>
        </div>
      </template>
      <template v-slot:page2>
        <div class="products-tea-fragment15">
          <span class="products-tea-text15">Products</span>
        </div>
      </template>
      <template v-slot:page3>
        <div class="products-tea-fragment16">
          <span class="products-tea-text16">Services</span>
        </div>
      </template>
      <template v-slot:page4>
        <div class="products-tea-fragment17">
          <span class="products-tea-text17">Contact</span>
        </div>
      </template>
      <template v-slot:action1>
        <div class="products-tea-fragment18">
          <span class="products-tea-text18">Sign In</span>
        </div>
      </template>
      <template v-slot:action2>
        <div class="products-tea-fragment19">
          <span class="products-tea-text19">Create</span>
        </div>
      </template>
      <template v-slot:page1Description>
        <div class="products-tea-fragment20">
          <span class="products-tea-text20">Page One Description</span>
        </div>
      </template>
      <template v-slot:page2Description>
        <div class="products-tea-fragment21">
          <span class="products-tea-text21">Page Two Description</span>
        </div>
      </template>
      <template v-slot:page3Description>
        <div class="products-tea-fragment22">
          <span class="products-tea-text22">Page Three Description</span>
        </div>
      </template>
      <template v-slot:page4Description>
        <div class="products-tea-fragment23">
          <span class="products-tea-text23">Page Four Description</span>
        </div>
      </template>
    </app-navbar8>
    <features-tea
      rootClassName="features-tearoot-class-name"
      feature1ImageSrc="/anisehyssop-600w.jpg"
      feature2ImageSrc="/chaga-600w.jpg"
      feature3ImageSrc="/chagachai-600w.jpg"
      feature4ImageSrc="/cocoapep-600w.jpg"
      feature4ImageSrc1="/lemonbalm-600w.jpg"
      feature4ImageSrc2="/sleepytime-600w.jpg"
      feature4ImageSrc11="/nettlerose-600w.jpg"
      feature4ImageSrc111="/orangespice-600w.jpg"
      feature4ImageSrc1111="/time2chill-600w.jpg"
    >
      <template v-slot:sectionTitle>
        <div class="products-tea-fragment24">
          <span class="products-tea-text24">Herbal Teas</span>
        </div>
      </template>
      <template v-slot:feature1Title>
        <div class="products-tea-fragment25">
          <span class="products-tea-text25">
            <span>Anise Hyssop</span>
            <br />
            <span><span v-html="rawo15o"></span></span>
          </span>
        </div>
      </template>
      <template v-slot:feature2Title>
        <div class="products-tea-fragment26">
          <span class="products-tea-text29">
            Chaga
            <span v-html="raw0f2u"></span>
          </span>
        </div>
      </template>
      <template v-slot:feature3Title>
        <div class="products-tea-fragment27">
          <span class="products-tea-text30">Chaga Chai</span>
        </div>
      </template>
      <template v-slot:feature4Title>
        <div class="products-tea-fragment28">
          <span class="products-tea-text31">Cocoa Peppermint</span>
        </div>
      </template>
      <template v-slot:sectionTitle1>
        <div class="products-tea-fragment29">
          <span class="products-tea-text32">*organic   ^locally grown</span>
        </div>
      </template>
      <template v-slot:feature1Button>
        <div class="products-tea-fragment30">
          <span class="products-tea-text33">Buy 0.5 oz ($5.00)</span>
        </div>
      </template>
      <template v-slot:feature2Button>
        <div class="products-tea-fragment31">
          <span class="products-tea-text34">Buy 1.5 oz ($10.00)</span>
        </div>
      </template>
      <template v-slot:feature3Button>
        <div class="products-tea-fragment32">
          <span class="products-tea-text35">Buy 1.5 oz ($10.00)</span>
        </div>
      </template>
      <template v-slot:feature4Button>
        <div class="products-tea-fragment33">
          <span class="products-tea-text36">Buy 1.0 oz ($10.00)</span>
        </div>
      </template>
      <template v-slot:feature4Title1>
        <div class="products-tea-fragment34">
          <span class="products-tea-text37">Lemon Balm</span>
        </div>
      </template>
      <template v-slot:feature4Title2>
        <div class="products-tea-fragment35">
          <span class="products-tea-text38">Goodnight</span>
        </div>
      </template>
      <template v-slot:sectionTitle11>
        <div class="products-tea-fragment36">
          <span class="products-tea-text39">
            <span>
              Handcrafted herbal teas made from the finest organic ingredients.
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature4Button1>
        <div class="products-tea-fragment37">
          <span class="products-tea-text42">Buy 0.5 oz ($5.00)</span>
        </div>
      </template>
      <template v-slot:feature4Button2>
        <div class="products-tea-fragment38">
          <span class="products-tea-text43">Buy 0.5 oz ($10.00)</span>
        </div>
      </template>
      <template v-slot:feature4Title11>
        <div class="products-tea-fragment39">
          <span class="products-tea-text44">
            <span>
              Nettle Rose
              <span v-html="rawg9xn"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature4Button11>
        <div class="products-tea-fragment40">
          <span class="products-tea-text47">Buy 0.5 oz ($5.00)</span>
        </div>
      </template>
      <template v-slot:feature4Title111>
        <div class="products-tea-fragment41">
          <span class="products-tea-text48">Orange Spice</span>
        </div>
      </template>
      <template v-slot:feature4Button111>
        <div class="products-tea-fragment42">
          <span class="products-tea-text49">Buy 1.5 oz ($10.00)</span>
        </div>
      </template>
      <template v-slot:feature4Title1111>
        <div class="products-tea-fragment43">
          <span class="products-tea-text50">Time to Chill</span>
        </div>
      </template>
      <template v-slot:feature4Button1111>
        <div class="products-tea-fragment44">
          <span class="products-tea-text51">Buy 0.5 oz ($5.00)</span>
        </div>
      </template>
      <template v-slot:feature1Description>
        <div class="products-tea-fragment45">
          <span class="products-tea-text52">
            <span>^Anise Hyssop</span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature2Description>
        <div class="products-tea-fragment46">
          <span class="products-tea-text55">
            <span>Local sustainably harvested Chaga.</span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature3Description>
        <div class="products-tea-fragment47">
          <span class="products-tea-text58">
            <span>
              Local sustainably harvested Chaga, *Amla fruit, *ginger root, *
              Clove, *Cinnamon bark, *Pepper
              <span v-html="rawq3gy"></span>
            </span>
            <br />
            <span>Corns.</span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature4Description>
        <div class="products-tea-fragment48">
          <span class="products-tea-text63">*Peppermint leaf, *Cocoa nibs</span>
        </div>
      </template>
      <template v-slot:feature4Description1>
        <div class="products-tea-fragment49">
          <span class="products-tea-text64">*^lemon balm</span>
        </div>
      </template>
      <template v-slot:feature4Description2>
        <div class="products-tea-fragment50">
          <span class="products-tea-text65">
            <span>
              *passion flower, *lemon balm, ^valerian leaf, ^chamomile
              <span v-html="raw6x0w"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature4Description11>
        <div class="products-tea-fragment51">
          <span class="products-tea-text68">^nettle leaf, *wild rose petals</span>
        </div>
      </template>
      <template v-slot:feature4Description111>
        <div class="products-tea-fragment52">
          <span class="products-tea-text69">
            <span>*orange peel, *cinnamon bark, *ginger bark</span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature4Description1111>
        <div class="products-tea-fragment53">
          <span class="products-tea-text72">
            ^red clover, ^calendula flower, *st john’s wort, * lemon balm
          </span>
        </div>
      </template>
    </features-tea>
    <app-footer4 rootClassName="footer4root-class-name3">
      <template v-slot:termsLink>
        <div class="products-tea-fragment54">
          <span class="products-tea-text73">Terms of Service</span>
        </div>
      </template>
      <template v-slot:cookiesLink>
        <div class="products-tea-fragment55">
          <span class="products-tea-text74">Cookies Settings</span>
        </div>
      </template>
      <template v-slot:privacyLink>
        <div class="products-tea-fragment56">
          <span class="products-tea-text75">Privacy Policy</span>
        </div>
      </template>
    </app-footer4>
  </div>
</template>

<script>
import AppNavbar8 from '../components/navbar8'
import FeaturesTea from '../components/features-tea'
import AppFooter4 from '../components/footer4'

export default {
  name: 'ProductsTea',
  props: {},
  components: {
    AppNavbar8,
    FeaturesTea,
    AppFooter4,
  },
  data() {
    return {
      rawo15o: ' ',
      raw0f2u: ' ',
      rawg9xn: ' ',
      rawq3gy: ' ',
      raw6x0w: ' ',
    }
  },
  metaInfo: {
    title: 'Products-Tea - Wildwood Herbs',
    meta: [
      {
        property: 'og:title',
        content: 'Products-Tea - Wildwood Herbs',
      },
    ],
  },
}
</script>

<style scoped>
.products-tea-container {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
 
.products-tea-fragment10 {
  display: contents;
}
 
.products-tea-text10 {
  display: inline-block;
}
 
.products-tea-fragment11 {
  display: contents;
}
 
.products-tea-text11 {
  display: inline-block;
}
 
.products-tea-fragment12 {
  display: contents;
}
 
.products-tea-text12 {
  display: inline-block;
}
 
.products-tea-fragment13 {
  display: contents;
}
 
.products-tea-text13 {
  display: inline-block;
}
 
.products-tea-fragment14 {
  display: contents;
}
 
.products-tea-text14 {
  display: inline-block;
}
 
.products-tea-fragment15 {
  display: contents;
}
 
.products-tea-text15 {
  display: inline-block;
}
 
.products-tea-fragment16 {
  display: contents;
}
 
.products-tea-text16 {
  display: inline-block;
}
 
.products-tea-fragment17 {
  display: contents;
}
 
.products-tea-text17 {
  display: inline-block;
}
 
.products-tea-fragment18 {
  display: contents;
}
 
.products-tea-text18 {
  display: inline-block;
}
 
.products-tea-fragment19 {
  display: contents;
}
 
.products-tea-text19 {
  display: inline-block;
}
 
.products-tea-fragment20 {
  display: contents;
}
 
.products-tea-text20 {
  display: inline-block;
}
 
.products-tea-fragment21 {
  display: contents;
}
 
.products-tea-text21 {
  display: inline-block;
}
 
.products-tea-fragment22 {
  display: contents;
}
 
.products-tea-text22 {
  display: inline-block;
}
 
.products-tea-fragment23 {
  display: contents;
}
 
.products-tea-text23 {
  display: inline-block;
}
 
.products-tea-fragment24 {
  display: contents;
}
 
.products-tea-text24 {
  display: inline-block;
}
 
.products-tea-fragment25 {
  display: contents;
}
 
.products-tea-text25 {
  display: inline-block;
}
 
.products-tea-fragment26 {
  display: contents;
}
 
.products-tea-text29 {
  display: inline-block;
}
 
.products-tea-fragment27 {
  display: contents;
}
 
.products-tea-text30 {
  display: inline-block;
}
 
.products-tea-fragment28 {
  display: contents;
}
 
.products-tea-text31 {
  display: inline-block;
}
 
.products-tea-fragment29 {
  display: contents;
}
 
.products-tea-text32 {
  display: inline-block;
}
 
.products-tea-fragment30 {
  display: contents;
}
 
.products-tea-text33 {
  display: inline-block;
}
 
.products-tea-fragment31 {
  display: contents;
}
 
.products-tea-text34 {
  display: inline-block;
}
 
.products-tea-fragment32 {
  display: contents;
}
 
.products-tea-text35 {
  display: inline-block;
}
 
.products-tea-fragment33 {
  display: contents;
}
 
.products-tea-text36 {
  display: inline-block;
}
 
.products-tea-fragment34 {
  display: contents;
}
 
.products-tea-text37 {
  display: inline-block;
}
 
.products-tea-fragment35 {
  display: contents;
}
 
.products-tea-text38 {
  display: inline-block;
}
 
.products-tea-fragment36 {
  display: contents;
}
 
.products-tea-text39 {
  display: inline-block;
}
 
.products-tea-fragment37 {
  display: contents;
}
 
.products-tea-text42 {
  display: inline-block;
}
 
.products-tea-fragment38 {
  display: contents;
}
 
.products-tea-text43 {
  display: inline-block;
}
 
.products-tea-fragment39 {
  display: contents;
}
 
.products-tea-text44 {
  display: inline-block;
}
 
.products-tea-fragment40 {
  display: contents;
}
 
.products-tea-text47 {
  display: inline-block;
}
 
.products-tea-fragment41 {
  display: contents;
}
 
.products-tea-text48 {
  display: inline-block;
}
 
.products-tea-fragment42 {
  display: contents;
}
 
.products-tea-text49 {
  display: inline-block;
}
 
.products-tea-fragment43 {
  display: contents;
}
 
.products-tea-text50 {
  display: inline-block;
}
 
.products-tea-fragment44 {
  display: contents;
}
 
.products-tea-text51 {
  display: inline-block;
}
 
.products-tea-fragment45 {
  display: contents;
}
 
.products-tea-text52 {
  display: inline-block;
}
 
.products-tea-fragment46 {
  display: contents;
}
 
.products-tea-text55 {
  display: inline-block;
}
 
.products-tea-fragment47 {
  display: contents;
}
 
.products-tea-text58 {
  display: inline-block;
}
 
.products-tea-fragment48 {
  display: contents;
}
 
.products-tea-text63 {
  display: inline-block;
}
 
.products-tea-fragment49 {
  display: contents;
}
 
.products-tea-text64 {
  display: inline-block;
}
 
.products-tea-fragment50 {
  display: contents;
}
 
.products-tea-text65 {
  display: inline-block;
}
 
.products-tea-fragment51 {
  display: contents;
}
 
.products-tea-text68 {
  display: inline-block;
}
 
.products-tea-fragment52 {
  display: contents;
}
 
.products-tea-text69 {
  display: inline-block;
}
 
.products-tea-fragment53 {
  display: contents;
}
 
.products-tea-text72 {
  display: inline-block;
}
 
.products-tea-fragment54 {
  display: contents;
}
 
.products-tea-text73 {
  display: inline-block;
}
 
.products-tea-fragment55 {
  display: contents;
}
 
.products-tea-text74 {
  display: inline-block;
}
 
.products-tea-fragment56 {
  display: contents;
}
 
.products-tea-text75 {
  display: inline-block;
}
</style>
